import {request} from './api'
const api = {
   //图书详情页
   letterData(id){
      return request({
         method:'Gets',
         url:'/api/share/select/'+id,
      })
   },
 


}
export default api